export const getColor = (position: number): string => {
  if (position === 1) return 'yellow'
  if (position === 2) return 'white'
  if (position === 3) return 'orange'
  return 'blue'
}
